import React, { useContext } from "react";
import DetailStyle from "./DetailStyle.module.css";
//import context

import { CourcesContext } from "../context/CourcesContextProvider";

//import reactrouter dom
import { useParams, Link } from "react-router-dom";

const Detail = (props) => {
  const params = useParams();
  const id = params._id;
  const cources = useContext(CourcesContext);
  console.log(cources[1]);
  const index = cources.findIndex((item) => item._id === id);

  const { title, cost, course, capacity } = cources[index];

  return (
    <div className={DetailStyle.Card}>
      <div className={DetailStyle.imgContainer}>
        {" "}
        <img alt='top'
          style={{ width: "100%" }}
          src={require(`../../src/assets/products/${course.image}`).default}
        />
      </div>
      <div className={DetailStyle.title}>
        <h3>{title}</h3>
      </div>
      <div className={DetailStyle.teacher}>
        {" "}
        <h4>
          <span style={{ color: "orange", marginLeft: "2px" }}>مدرس</span>:
          <span style={{ marginRight: "2px" }}>محمدحسین پولانی</span>
        </h4>
      </div>
      <h4>
        <span style={{ color: "orange", marginLeft: "2px" }}>ظرفیت</span>:
        <span style={{ marginRight: "2px" }}>{capacity}</span>
      </h4>{" "}
      <h4><span style={{ color: "orange", marginLeft: "2px" }}>قیمت</span>:<span style={{ marginRight: "2px",color:"green" }}>{cost}تومان</span></h4>
      <div className={DetailStyle.description}>
        <p>{course.description}</p>
      </div>
      <div className={DetailStyle.backbutton}><Link to="/">بازگشت</Link></div>
    </div>
  );
};

export default Detail;
